<template>
  <div id="app">
      <template v-if="menteflg">
          <Mente />
      </template>

      <template v-if="!menteflg">
    <!-- ============  Header ============ -->
    <HeaderItem />

    <!-- 3. Menu contents Search form -->
    <SearchPage />
    <!-- / menu-contents -->

    <!-- ============  Contents ============== -->
    <div class="wrapper">
      <div id="content">
        <transition name="fade">
          <router-view></router-view>
        </transition>
      </div>
      <!-- / contents -->
    </div>
    <!-- / wrapper -->
    <!-- ============  Contents END ========== -->

    <!-- ガイドコンポーネント -->
    <GuideView />

    <CompWord />
    <!-- test -->
    <!-- Modal コンテンツ -->

    <!-- test end -->
      </template>
  </div>
</template>
<script>
import HeaderItem from "@/components/HeaderItem.vue";
import SearchPage from "@/components/SearchPage.vue";
import GuideView from "@/components/GuideView.vue";
import CompWord from "@/components/CompWord.vue";
import Mente from './views/Mente.vue'
import {API_URL} from '@/services/config'

//const API_URL = 'http://localhost:8000/api'

export default {
  name: "app",
  components: {
    HeaderItem,
    SearchPage,
    GuideView,
    CompWord,
    Mente
  },
  data(){
    return{
    menteflg: false,
    }
  },
  created(){
      var self = this
   self.$axios.get(`${API_URL}/search/getsysteminfo`)
    .then((res)=>{
        if(res.data.teishi_flg!='0'){
            self.menteflg = false;
        }
    })
    .catch(err=>{
        console.log('err end');
    });
  },
  computed: {
    isSearchBox() {
      return this.$store.getters.isSearchBox;
    },
    jpListData() {
      return this.$store.getters.jpListData;
    },
    isGuide() {
      return this.$store.getters.isGuide;
    }
  },
  methods: {
    closeguide() {
      this.$store.dispatch("upIsGuide", false);
    }
  }
};
</script>
<style>
</style>
<style lang="scss">
@import "./assets/styles/custom.scss";
@import "./assets/styles/test.scss";
</style>
